export var LogoSize;
(function (LogoSize) {
    LogoSize["BIG"] = "big";
    LogoSize["SMALL"] = "small";
    LogoSize["XSMALL"] = "xsmall";
})(LogoSize || (LogoSize = {}));
